module.exports = __webpack_public_path__ + "img/home-title1.be6908f4.png";